export const addTrailingS = (s: string) =>
  s[s.length - 1] !== "s" ? `${s}s` : s;

export default addTrailingS;
